import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Rocket } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { fmtDate } from "@/components/manual/icons";

export const SEEN_KEY = "manual_seen_version";

export const NewVersionDialog = ({ info }) => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [ready, setReady] = useState(false);
  const [titles, setTitles] = useState({});
  const unseen = info && localStorage.getItem(SEEN_KEY) !== info.version && !pathname.startsWith("/manuale");
  useEffect(() => {
    const on = () => setReady(true);
    window.addEventListener("welcome-done", on);
    return () => window.removeEventListener("welcome-done", on);
  }, []);
  useEffect(() => {
    if (!unseen || !user || !ready) return;
    api.get("/manual").then((r) => setTitles(Object.fromEntries(r.data.sections.map((s) => [s.id, s.title])))).catch(() => {});
    setOpen(true);
  }, [unseen, user?.id, ready]); // eslint-disable-line react-hooks/exhaustive-deps
  const close = () => { localStorage.setItem(SEEN_KEY, info.version); setOpen(false); };
  if (!info || !open) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-h-[90vh] w-[calc(100%-2rem)] max-w-lg overflow-y-auto rounded-2xl" data-testid="new-version-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading"><Rocket className="h-5 w-5 text-teal-600" />Novità della versione {info.version}</DialogTitle>
        </DialogHeader>
        <p className="-mt-2 text-sm text-slate-500" data-testid="new-version-subtitle">{info.title}{info.date ? ` · ${fmtDate(info.date)}` : ""}</p>
        <ul className="max-h-[45vh] space-y-2 overflow-y-auto pr-1" data-testid="new-version-items">
          {info.items.map((it, i) => (
            <li key={i} className="flex gap-2 rounded-xl border border-slate-200 bg-slate-50/60 p-3 text-sm text-slate-700">
              <span className="shrink-0 rounded bg-blue-50 px-1.5 py-0.5 text-xs font-medium text-blue-700">{titles[it.section] || it.section}</span>
              <span>{it.text}</span>
            </li>
          ))}
        </ul>
        <div className="flex flex-wrap justify-end gap-2">
          <Button variant="outline" data-testid="new-version-close" onClick={close}>Chiudi</Button>
          <Button data-testid="new-version-manual" className="bg-teal-600 hover:bg-teal-700" onClick={() => { close(); nav("/manuale/novita"); }}>Leggi nel manuale</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
